import { Button, EmptyHighlightsContainer, Image, SubTitle, Title } from './EmptyHighlights.styles';

import { EmptyHighlightsProps } from '../types';
import { FC } from 'react';
import FlexContainer from 'features/common/components/FlexContainer/FlexContainer';
import { PRIMARY } from 'features/common/components/Button/constants';
import { ROUTES } from 'features/routes';
import { common } from 'theme';
import emptyHighlightsPhoto from 'assets/images/emptyHighlights.svg';
import highlightsHasLogoEmptyPhoto from 'assets/images/highlightsHasLogoEmpty.svg';
import { useHistory } from 'react-router-dom';
import { useResponsiveScreen } from 'hooks/useWindowSize';
import { useTranslation } from 'react-i18next';

const EmptyHighlights: FC<EmptyHighlightsProps> = ({ hasLogo }) => {
	const { push } = useHistory();
	const { t } = useTranslation();
	const isLargeScreen = useResponsiveScreen();

	const createEvent = () => push(ROUTES.CREATE_EVENT_PATH);

	const hasLogoAndIsLargeScreen = hasLogo && isLargeScreen;

	return (
		<EmptyHighlightsContainer hasLogo={hasLogo}>
			<Image src={hasLogoAndIsLargeScreen ? highlightsHasLogoEmptyPhoto : emptyHighlightsPhoto} />
			<FlexContainer
				flexDirection="column"
				alignItems={isLargeScreen ? 'flex-start' : 'center'}
				backgroundColor={isLargeScreen ? 'transparent' : common.colors.grey}
				boxSizing="border-box"
				padding="8px 16px 8px 0"
				minWidth="250px"
			>
				<Title element="h2">{t(`home-highlights${hasLogoAndIsLargeScreen ? '-hasLogo' : ''}-empty-title`)}</Title>
				<SubTitle element="h3">{t(`home-highlights${!isLargeScreen ? '-mobile' : ''}-empty-subtitle`)}</SubTitle>
				<Button text={t('home-createEvent')} category={PRIMARY} type="button" onClick={createEvent} />
			</FlexContainer>
		</EmptyHighlightsContainer>
	);
};

export { EmptyHighlights };
